import { store } from '@/src/stores/store'
import clsx from 'clsx'
import { motion } from 'motion/react'
import { playChangeConfigValueSound } from '@/src/game/audio/uiSounds'
import type { PointerEvent as ReactPointerEvent } from 'react'

type ColorButtonProps = {
    color: {
        id: string
        label: string
        value: string
        border: string
        gradient: string
    }
    isActive?: boolean
}

export default function ColorButton({ color, isActive = false }: ColorButtonProps) {
    const handlePointerDown = (event: ReactPointerEvent<HTMLButtonElement>) => {
        if (event.pointerType === 'touch') {
            event.preventDefault()
        }

        store.setChameleonTexture(color.id)
        playChangeConfigValueSound()
    }

    return (
        <div className={clsx(
            'flex justify-center items-center',
            'w-11 h-11 min-w-11 min-h-11 max-w-11 max-h-11',
            'stele:w-44 stele:h-44 stele:min-w-44 stele:min-h-44 stele:max-w-44 stele:max-h-44'
        )}
        >
            <motion.button
                key={color.value}
                initial={{ scale: 0 }}
                animate={{
                    scale: isActive ? 1.2 : 1,
                }}
                whileTap={{ scale: 0.85 }}
                type='button'
                aria-label={color.label}
                aria-pressed={isActive}
                onPointerDown={handlePointerDown}
                onPointerUp={() => { }}
                onPointerCancel={() => { }}
                className={clsx(
                    'flex justify-center rounded-full color-button-gradient',
                    'w-full h-full',
                    isActive && 'active-ring'
                )}
                style={{
                    backgroundColor: color.value,
                    borderColor: color.value,
                    filter: `drop-shadow(0 var(--btn-shadow-offset) 0 ${color.border})`,
                    border: `var(--btn-border-width) solid ${color.border}`,
                    ['--bottom-pattern' as string]: `url('${color.gradient}')`,
                }}
                transition={{
                    scale: {
                        type: 'spring',
                        stiffness: 420,
                        damping: 22,
                        mass: 0.7,
                    },
                }}
            >
                <div
                    className={clsx(
                        'absolute bg-shine-gradient rounded-full',
                        'top-1 w-4 h-4',
                        'stele:top-4 stele:w-16 stele:h-16'
                    )}
                />
            </motion.button>
        </div>
    )
}
